<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog v-model="dialog" persistent id="export" width="1000px" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card :loading="loading.devices">
      <v-card-title>
        <div class="text-h6 text-sm-h4">
          {{ language.t("RoadProfiler.Export.filter") }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon color="blue darken-1" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>

        <v-container>
          <v-row>
            <v-col class="d-flex align-end justify-center">
              <v-container>
                <v-row>
                  <v-col class="pa-0 d-flex align-end justify-center">
                    <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="startDate" prepend-icon="mdi-calendar" :label="language.t('FormFields.DateRange.startDate')"
                          :hint="language.t('RoadProfiler.Export.dateRangeHint')" persistent-hint v-bind="attrs"
                          v-on="on" style="padding-top:22px" :rules="[startDateRule]">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="startDate" @input="menuStart = startDate ? false : true"
                        :first-day-of-week="1">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pa-0 d-flex align-end justify-center">
                    <v-menu v-model="menuEnd" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="endDate" prepend-icon="mdi-calendar" :label="language.t('FormFields.DateRange.endDate')"
                          :hint="language.t('RoadProfiler.Export.dateRangeHint')" persistent-hint v-bind="attrs"
                          v-on="on" style="padding-top:22px" :rules="[endDateRule]">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="endDate" @input="menuEnd = endDate ? false : true" :first-day-of-week="1">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col class="d-flex align-center justify-center">
              <DeviceSelect v-model="selectedDevices" :devices="devices" />
            </v-col>
            <v-col class="d-flex align-center justify-center">
              <TaskSelect v-model="selectedTask" :hint="language.t('RoadProfiler.Export.taskHint')" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="card-actions">
        <v-spacer></v-spacer>
        <v-btn :loading="loading.productionList || loading.devices"
          :disabled="(!startDate || !endDate) && !selectedTask" @click="getProduction">
          <v-icon>mdi-table-search</v-icon>{{ language.t("RoadProfiler.Export.btnView") }}
        </v-btn>
        <v-btn :disabled="(!startDate || !endDate) && !selectedTask" :loading="loading.excel || loading.devices"
          @click="getProductionExcel">
          <v-icon>mdi-file-download</v-icon>{{ language.t("RoadProfiler.Export.btnExcel") }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="$emit('close')">
          <v-icon>mdi-close</v-icon>{{ language.t("App.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2  overflow-y-auto" style="max-height:calc(90vh - 372px - 2px)" :loading="loading.productionList">
      <v-card-title class="py-6">
        <div class="text-h6 text-sm-h4">
          {{ language.t("RoadProfiler.Export.production") }}
        </div>
      </v-card-title>
      <v-card-text>
        <RBPProductionList ref="rbpProductionList" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DeviceSelect from "../formfields/DeviceSelect.vue";
import DateRange from "../formfields/DateRange.vue";
// import TaskSelect from "../formfields/TaskSelect.vue";
import TaskSelect from "../formfields/ImprovedTaskSelect.vue";
import RBPProductionList from "./ProductionList.vue";
import * as CONST from "../../Constants";

export default {
  components: {
    DeviceSelect,
    DateRange,
    TaskSelect,
    RBPProductionList,
  },
  props: {},
  data() {
    return {
      menuStart: false,
      menuEnd: false,

      devices: [],
      dialog: true,
      startDate: null,
      endDate: null,
      selectedDevices: [],
      selectedTask: null,
      loading: {
        excel: false,
        productionList: false,
        devices: false,
      },
      startDateRule: true,
      endDateRule: true,
    };
  },
  mounted: function () {
    this.getDevices();
    // this.getTasks();
  },
  computed: {
  },
  watch: {
    selectedDevices(val) {
      console.log("device changed: " + val);
    },
    endDate(val) {
      console.log("endDate changed: " + val);

      if (val < this.startDate) {
        this.startDate = val;
      }

      if (this.startDate) {
        let oneMonthBefore = new Date(val);
        oneMonthBefore.setDate(oneMonthBefore.getDate() - 31);

        const startDate = new Date(this.startDate);
        const normalizeDate = (date) => {
          return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        }


        if (normalizeDate(startDate) < normalizeDate(oneMonthBefore)) {

          this.startDateRule = "Kan niet meer dan een maand productie ophalen";
          setTimeout(() => {
            this.startDateRule = true;
          }, 1000);

          this.startDate = this.formatDate(oneMonthBefore);
        }
      }
    },
    startDate(val) {
      console.log("startDate changed: " + val);
      // if startdate is after enddate set enddate to startdate.
      if (val > this.endDate) {
        this.startDate = this.endDate;
      }

      if (this.endDate) {
        let oneMonthLater = new Date(val);
        oneMonthLater.setDate(oneMonthLater.getDate() + 31);

        const endDate = new Date(this.endDate);
        const normalizeDate = (date) => {
          return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        }

        if (normalizeDate(endDate) > normalizeDate(oneMonthLater)) {
          console.log("CURRENT END DATE: " + endDate + ", IS AFTER: " + oneMonthLater)
          console.log(oneMonthLater.toISOString())
          this.endDateRule = "Kan niet meer dan een maand productie ophalen";
          setTimeout(() => {
            this.endDateRule = true;
          }, 1000);

          this.endDate = this.formatDate(oneMonthLater);
        }
      }
    },
    selectedTask(val) {
      console.log(val)
    }
  },
  methods: {
    formatDate(date) {
      var pad = function (i) { return (i < 10) ? '0' + i : i; };

      const y = date.getFullYear()
      const m = date.getMonth() + 1;
      const d = date.getDate();

      return pad(y) + "-" + pad(m) + "-" + pad(d)
    },
    onClose() {
      this.$emit("close");
    },
    getDevices() { // move to device select
      this.loading.devices = true;
      var _this = this;
      this.$axios.get(route("api.devices")).then((res) => {
        // TODO: check status
        _this.devices = res.data;
        this.loading.devices = false;
      });
    },
    getProduction() {
      const taskId = this.selectedTask ? this.selectedTask.id : null

      this.loading.productionList = true;
      this.$refs.rbpProductionList.empty();
      this.$refs.rbpProductionList.getProduction(
        this.selectedDevices,
        taskId,
        this.startDate,
        this.endDate,
        "GEO")
        .then((res) => {
          console.log(res)
          this.loading.productionList = false
        }).error(err => {
          console.error(err)
          this.loading.productionList = false
        });
    },
    getProductionExcel() {
      const taskId = this.selectedTask ? this.selectedTask.id : null

      this.loading.excel = true;
      var data = {
        devices: this.selectedDevices,
        taskId: taskId,
        startDate: this.startDate,
        endDate: this.endDate,
        unitSystem: this.$selectedUnitSystem
      };
      console.log(data);

      this.$axios.get(route("api.production.rbp.excel"), { params: data, responseType: "blob" }).then((res) => {
        console.log(res);
        // TODO: check status
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;

        try {
          // TODO: better filename
          if (!this.endDate || !this.startDate) {
            fileLink.setAttribute("download", `${this.selectedTask.name}.xlsx`);
          } else if (!this.selectedTask) {
            fileLink.setAttribute("download", `${this.startDate}-${this.endDate}.xlsx`);
          } else {
            fileLink.setAttribute("download", `${this.selectedTask.name}-${this.startDate}-${this.endDate}.xlsx`);
          }
        } catch (error) {
          fileLink.setAttribute("download", `production.xlsx`);
        }

        document.body.appendChild(fileLink);

        fileLink.click();

        this.loading.excel = false;
      });
    },
  },
};
</script>

<style scoped>
#export {
  max-width: 1000px;
}
</style>
